/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { foldersControllerCreate } from "./foldersControllerCreate";
import { foldersControllerFindAll } from "./foldersControllerFindAll";
import { foldersControllerFindOne } from "./foldersControllerFindOne";
import { foldersControllerRemove } from "./foldersControllerRemove";
import { foldersControllerUpdate } from "./foldersControllerUpdate";

export function foldersService() {
  return { foldersControllerCreate, foldersControllerFindAll, foldersControllerFindOne, foldersControllerUpdate, foldersControllerRemove }
}